import ReactCalendar from 'react-calendar';
import styled from 'styled-components';
import { lighten, desaturate } from 'polished';

const lessVars = {
	fontFamily: 'Roboto, sans-serif',
	fontLight: 300,
	fontMedium: 500,
	fontBold: 700
};

export const Calendar = styled(ReactCalendar)`
	border: none;
	width: 375px;
	max-width: 100%;
	background: white;
	font-family: ${lessVars.fontFamily};
	font-weight: ${lessVars.fontLight};
	line-height: 1.6875em;
	abbr[title] {
		text-decoration: none;
	}
	&--doubleView {
		width: 750px;

		.react-calendar__viewContainer {
			display: flex;
			margin: -0.75em;

			> * {
				width: 50%;
				margin: 0.75em;
			}
		}
	}

	&,
	& *,
	& *:before,
	& *:after {
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}

	button {
		margin: 0;
		outline: none;
		font-family: ${lessVars.fontFamily};
		border: 1px solid white;
		font-weight: ${lessVars.fontLight};

		&:enabled {
			&:hover {
				cursor: pointer;
			}
		}
	}

	.react-calendar__navigation {
		height: 52.5px;
		margin: 0;

		button {
			min-width: 52.5px;
			background: ${p => p.theme.colors.primary};
			color: white;
			border-color: ${p => p.theme.colors.primary};
			font-size: 1.125rem;

			&:enabled {
				&:hover,
				&:focus {
					background-color: ${p => lighten(0.2, p.theme.colors.primary)};
				}
			}

			&[disabled] {
				background-color: white;
				border: lightgrey;
			}
		}
	}

	.react-calendar__month-view {
		&__weekdays {
			text-align: center;
			text-transform: uppercase;
			background: ${p => lighten(0.2, desaturate(0.2, p.theme.colors.primary))};
			color: white;

			font-size: 0.9em;

			&__weekday {
				padding: 0.375em;
			}
		}

		&__weekNumbers {
			.react-calendar__tile {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 1.125em;
			}
		}

		&__days {
			&__day {
				font-size: 1.125em;
				display: flex;
				justify-items: flex-start;
				flex-direction: column;
				align-items: center;
				border: 1px solid ${p => p.theme.colors.paleGrey};
				&--weekend {
					background: ${p => p.theme.colors.paleGrey};
				}

				&--neighboringMonth {
					color: lighten(${p => p.theme.colors.darkGrey}, 10%);
				}
			}
		}
	}

	.react-calendar__year-view,
	.react-calendar__decade-view,
	.react-calendar__century-view {
		.react-calendar__tile {
			padding: 0.75em 0.375em;
		}
	}

	.react-calendar__tile {
		max-width: 100%;
		text-align: center;
		padding: 0.375em 0;
		background: none;

		&--now {
			border: 1px solid ${p => lighten(0.2, p.theme.colors.primary)} !important;
			color: ${p => p.theme.colors.primary};

			&:enabled {
				&:hover,
				&:focus {
					border: 1px solid ${p => lighten(0.2, desaturate(0.2, p.theme.colors.primary))};
				}
			}
		}

		&:disabled {
			background-color: white;
			border-color: ${p => p.theme.colors.paleGrey};
		}

		&:enabled {
			&:hover,
			&:focus {
				background-color: rgb(230, 230, 230);
			}
		}

		&--hasActive {
			background: ${p => lighten(0.2, p.theme.colors.primary)};

			&:enabled {
				&:hover,
				&:focus {
					background: ${p => lighten(0.3, p.theme.colors.primary)};
				}
			}
		}

		&--active {
			background: ${p => p.theme.colors.primary};
			color: white;

			&:enabled {
				&:hover,
				&:focus {
					background: ${p => lighten(0.1, p.theme.colors.primary)};
				}
			}
		}
	}

	.react-calendar--selectRange {
		.react-calendar__tile {
			&--hover {
				background-color: rgb(230, 230, 230);
			}
		}
	}
`;
